import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
import Headerpage from "src/components/header";
// import GoogleLogo from "src/assets/2702602.png";
import "src/pages/home/signUp-pages/style.css";
// import LoginGoogleForm from "src/components/LoginGoogleForm";
import LoginForm from "src/components/LoginForm";
import { Button } from "@material-ui/core";
import EmailIcon from '@material-ui/icons/Email'; 
import Footerpage from "src/components/footer";
import { useLocation } from "react-router-dom";
import { decodeEmailQueryParam } from "src/utils/queryParams";
const SignInpage: React.FC = () => {

    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    };

    const query = useQuery();
    const token = query.get("token");
    const email = decodeEmailQueryParam(query.get("email"));

    useEffect(() => {
        document.body.classList.add("signUp");
        window.scrollTo({ top: 0, behavior: 'smooth' });

        // Preserve invitation context during the OAuth callback, but clear
        // stale invitation data when starting a normal sign-in.
        const isGoogleCallback = Boolean(query.get("code"));
        if (!isGoogleCallback) {
          if (token && email) {
            localStorage.setItem("invitationToken", token);
            localStorage.setItem("invitationEmail", email);
          } else {
            localStorage.removeItem("invitationToken");
            localStorage.removeItem("invitationEmail");
          }
        }
        return () => {
          document.body.classList.remove("signUp");
        };
      }, [token, email]);

    return (<>

      <Headerpage/>
        <div className="container-inner">
            <div className=" content-leader"
                style={{
                    height:"calc(100vh - 153px)",
                    width: "100%",
                    backgroundImage: `-webkit-gradient(linear, left top, left bottom, from(rgba(62, 124, 177, 0.5)), to(rgba(62, 124, 177, 0.5))),url(${require('src/assets/gritp.jpg')})`
                }}>
 
                <div className="welcome-back welcome-sign-outer">
                    <div className="sign-In-back">
                        <h1 className="sign-in-head" style={{marginTop: "-5px"}}>Welcome to Grit Leadership!</h1>
                        {/* <Link to="/name"><button className="sign-btn"><img src={GoogleLogo}/><span>Sign up with Google</span></button></Link> */}
                        <div style={{marginTop: "-10px"}}>
                         <LoginForm/>
                        {/* <LoginGoogleForm /> */}
                        </div>
                        <div style={{marginTop: "10px"}}>
                        <Button
                         className="button-signup"
                                variant="contained"
                                color="primary"
                                style={{marginBottom:"35px"}}
                                onClick={()=>{window.location.href = "/password"}}
                              >
                                <EmailIcon style={{ marginRight: "10px" }}/>
                                Sign in with Email
                              </Button>
                              </div>
                    
                    </div>
                </div>

            </div>

        </div>
     \<Footerpage/>



    </>);
}
export default SignInpage;



// WEBPACK FOOTER //
// ./src/pages/home/signIn-page/signIn.tsx